import { IDepartment, IEmployee, iColaboradorSquad, ISquad } from '../../../../../../interfaces'

export function squadsParaOrganograma(squads: ISquad[], semHierarquia = false): IDepartment[] {
  const squadsComPessoas = squads.filter(squad => squad.colaboradores?.length > 0)

  if (semHierarquia) {
    return squadsComPessoas.map(squad => ({
      id: squad.id,
      nome: squad.nome,
      colaboradores: squad.colaboradores.map(colaborador => montarNo(squad.id, colaborador)),
      departamentoFilhos: []
    }))
  }

  const departamentos: IDepartment[] = squadsComPessoas.map(squad => ({
    id: squad.id,
    nome: squad.nome,
    colaboradores: montarArvore(squad.id, squad.colaboradores),
    departamentoFilhos: []
  }))

  const paiPorSquad = new Map<string, string>()
  squadsComPessoas.forEach(squad => {
    const pai = descobrirSquadPai(squad, squadsComPessoas)
    if (pai && !ehAncestral(pai, squad.id, paiPorSquad)) paiPorSquad.set(squad.id, pai)
  })

  departamentos.forEach(departamento => {
    const pai = departamentos.find(outro => outro.id === paiPorSquad.get(departamento.id))
    pai?.departamentoFilhos?.push(departamento)
  })

  return departamentos.filter(departamento => !paiPorSquad.has(departamento.id))
}

// o squad pai é o que contém o gestor de quem está no topo deste squad
function descobrirSquadPai(squad: ISquad, todos: ISquad[]): string | undefined {
  const idsDoSquad = new Set(squad.colaboradores.map(colaborador => colaborador.id))
  const votos = new Map<string, number>()

  squad.colaboradores
    .filter(colaborador => colaborador.gestorId && !idsDoSquad.has(colaborador.gestorId))
    .forEach(colaborador => {
      todos
        .filter(outro => outro.id !== squad.id && outro.colaboradores.some(candidato => candidato.id === colaborador.gestorId))
        .forEach(outro => votos.set(outro.id, (votos.get(outro.id) ?? 0) + 1))
    })

  return Array.from(votos.entries()).sort((a, b) => b[1] - a[1])[0]?.[0]
}

function ehAncestral(candidato: string, squadId: string, paiPorSquad: Map<string, string>): boolean {
  let atual: string | undefined = candidato
  while (atual) {
    if (atual === squadId) return true
    atual = paiPorSquad.get(atual)
  }
  return false
}

// quem responde a alguém de fora do squad vira topo da própria árvore
function montarArvore(squadId: string, colaboradores: iColaboradorSquad[]): IEmployee[] {
  const idsDoSquad = new Set(colaboradores.map(colaborador => colaborador.id))

  function montarArvoreDe(colaborador: iColaboradorSquad): IEmployee {
    const subordinados = colaboradores
      .filter(outro => outro.gestorId === colaborador.id)
      .map(montarArvoreDe)

    return montarNo(squadId, colaborador, subordinados)
  }

  return colaboradores
    .filter(colaborador => !colaborador.gestorId || !idsDoSquad.has(colaborador.gestorId))
    .map(montarArvoreDe)
}

function montarNo(squadId: string, colaborador: iColaboradorSquad, subordinados: IEmployee[] = []): IEmployee {
  return {
    id: colaborador.id,
    nome: colaborador.nome,
    sobrenome: '',
    avatar: colaborador.avatar,
    papelSquad: colaborador.hierarquiaSquads.find(papel => papel.tagsPaiId?.includes(squadId))?.texto,
    subordinados: subordinados.length > 0 ? subordinados : undefined
  } as unknown as IEmployee
}
